import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyBGyx--CcYKJHPjylY_hH_sMeNDKdot6jM',
  authDomain: 'adibau-birhday.firebaseapp.com',
  projectId: 'adibau-birhday',
  storageBucket: 'adibau-birhday.firebasestorage.app',
  messagingSenderId: '1067796243668',
  appId: '1:1067796243668:web:8ffbced2515c76eb7a0741',
  measurementId: 'G-VTMWTTZBNS',
};
const vapidKey = 'BFtgW8KfyIlxvniOTt6xiIsmz9dVkxVGIHq1u-4o78o6fDP9DgCXABBeJGEd7nSA4qhA2JmwFl1SP3XPDdvO3h4';

// Initialize Firebase
const appConfig = initializeApp(firebaseConfig);
export const messaging = getMessaging(appConfig);

export const generateToken = async () => {
  if (!('Notification' in window)) {
    return 'not granted';
  }
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    const token = await getToken(messaging, {
      vapidKey: vapidKey,
    });

    if (token === null || token === undefined || token.length < 10) {
      const newToken = (await generateToken()) as string;
      return newToken;
    }
    return token;
  } else {
    return 'not granted';
  }
};
